import type { AccountId, AccountNumber } from '../../generated-types';
import { deleteAccount } from '../../services/accountService';

export interface DeleteAccountProps {
    accountId: AccountId;
    transferTo: AccountNumber;
}

export default ({ accountId, transferTo }: DeleteAccountProps) => {
    return deleteAccount(accountId, transferTo);
};
